import Vue from 'vue'
import VueRouter from 'vue-router'
import workbench from './workbench'
import iv from './interactive-video'

Vue.use(VueRouter)

const routes = [
  workbench,
  iv,
  {
    path: '/icon',
    name: 'icon',
    // route level code-splitting
    // this generates a separate chunk (icon.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "icon" */ '@ps/views/icon/index.vue'),
  },
]

const router = new VueRouter({
  routes,
})

export default router
